import { useEffect, useState } from "react";
import AddButton from "../../../../components/AddButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import TableFilters from "../TableFilters";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import {
  addStateProdCodetype,
  editStateProdCodetype,
  selectedRowsStateProducerCodeType,
} from "./atoms/atoms";
import { useProducerCodeType } from "./hooks/useProducerCodeType";
import useAddProdCodeType from "./hooks/useAddProdCodeType";
import useDeleteProdCodeType from "./hooks/useDeleteProdCodeType";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import useUpdateProdCodeType from "./hooks/useUpdateProdCodeType";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import MaterialProducerCodeConfigTable from "../../../../components/tables/MaterialProducerCodeConfigTable";

const ProducerCodeTypeTable = () => {
  const queryClient = useQueryClient();
  const [producerTypeData, setProducerTypeData] = useState([]);
  const [editRowData, setEditRowData] = useState();
  const [addState, setAddState] = useRecoilState(addStateProdCodetype);
  const [editState, setEditState] = useRecoilState(editStateProdCodetype);
  const [, setCheckStatus] = useState(false);
  const [rowsCount, setRowsCount] = useState(0);
  const newRow = {
    producerCodeTypesId: 0,
    producerCodeTypesName: "",
    createdDate: null,
    createdBy: null,
    isActive: true,
  };

  const [newData, setNewData] = useState([newRow]);
  const [prodCodeTypeFilteredData, setProdCodeTypeFilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [disableSave, setDisableSave] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateProducerCodeType
  );

  const [filterText, setFilterText] = useState("");
  const [, setDisabledButton] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [updatedStatus, setUpdatedStatus] = useState(false);

  const prodTypeData = useProducerCodeType();
  const BulkDeleteProducerCodeType = useDeleteProdCodeType();
  const editProdCodeType = useUpdateProdCodeType();
  const { mutateAsync: addProducerCodeType } = useAddProdCodeType();

  const [, setLOBTypeFilteredData] = useState([]);
  const [, setCProgramFilteredData] = useState([]);
  const [, setMgaFilteredData] = useState([]);
  const [, setDisChannelFilteredData] = useState([]);
  const [, setCodeLevelFilteredData] = useState([]);

  //Permission
  const hasEdit = PERMISSIONS.permission_utilities_producercodetype_edit;
  const hasAdd = PERMISSIONS.permission_utilities_producercodetype_add;
  const hasDelete = PERMISSIONS.permission_utilities_producercodetype_delete;
  const userPermissions = useRecoilValue(permissionsSelector);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (prodTypeData.data) {
      setProducerTypeData(prodTypeData.data);
    }
  }, [prodTypeData.data]);

  //Filter
  const [prodCodeTypeId, setProdCodeTypeId] = useState("");
  useEffect(() => {
    if (filterText) {
      setProducerTypeData(
        prodTypeData.data?.filter((x) =>
          x.producerCodeTypesName
            .toLowerCase()
            .includes(filterText.trim().toLowerCase())
        )
      );
    } else if (prodCodeTypeId?.includes(".")) {
      let prodCodeTypeIds = prodCodeTypeId.split(".");
      const prodCodeTypeIdsArr = prodCodeTypeIds.map((id) => Number(id));
      const filteredData = prodTypeData.data?.filter((x) =>
        prodCodeTypeIdsArr.includes(x.producerCodeTypesId)
      );

      setProdCodeTypeFilteredData(filteredData);
    } else if (prodCodeTypeFilteredData?.length === 1) {
      const filteredData = prodTypeData.data?.filter(
        (x) => x.producerCodeTypesId === Number(prodCodeTypeId)
      );

      setProdCodeTypeFilteredData(filteredData);
    } else {
      setProducerTypeData(prodTypeData.data);
    }
    setEditState(false);
    setAddState(false);
  }, [filterText, prodTypeData.data]);

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setProdCodeTypeFilteredData(result);
          setProdCodeTypeId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  //Cancel
  const handleCancel = () => {
    setEditState(false);
    setAddState(false);
    setEditRowData();
    setDisabledButton(false);
    setNewData([newRow]);
    setUpdatedStatus(false);
  };

  //handle input fields changes
  const handlesFieldsChange = (fieldName, value) => {
    if (addState) {
      setNewData((data) => [{ ...data[0], [fieldName]: value }]);
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    } else {
      //else Edit State
      setEditRowData({ ...editRowData, [fieldName]: value });
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    }
  };

  //handle Add Button
  const handleAdd = () => {
    setAddState(true);
    setDisabledButton(true);
    setUpdatedStatus(true);
  };

  //handle Edit Button
  const handleEdit = (rowData) => {
    setCheckStatus(rowData.isActive);
    setEditState(true);
    setDisabledButton(true);
    setEditRowData({ ...rowData });
    setUpdatedStatus(rowData.isActive);
  };

  //save changes
  const handleSave = () => {
    setOpenModal(false);
    if (addState) {
      addProducerCodeType(
        { ...newData },
        {
          onSuccess: (res) => {
            setDisabledButton(false);
            if (res.data === "duplicate") {
              toast.fire("Failed", "Producer Code Type already exist", "error");
            } else if (res.status === 201) {
              setAddState(false);
              setNewData([newRow]);
              queryClient.invalidateQueries("GetProducerCodeType");
              toast.fire(
                "Success",
                "New Producer Code Type added successfully",
                "success"
              );
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Producer Code Type",
                "error"
              );
            }
          },
          onError: (error) => {
            if (
              error.response.data.message === "Failed sending of email" ||
              error.response.data.message === "Failed inserting of notification"
            ) {
              toast.fire(
                "Success",
                "New Producer Code Type added successfully, but " +
                  error.response.data.message,
                "warning"
              );
              queryClient.invalidateQueries("GetProducerCodeType");
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Producer Code Type",
                "error"
              );
            }
          },
        }
      );
    } else {
      //else for if c
      const prodCodeType = editRowData.producerCodeTypesName.trim();
      const prodCodeTypeData = producerTypeData.filter(
        (x) => x.producerCodeTypesName === prodCodeType
      );

      if (
        prodCodeType === prodCodeTypeData[0]?.producerCodeTypesName &&
        editRowData.isActive === prodCodeTypeData[0]?.isActive
      ) {
        toast.fire("Saving Failed", "No Changes have been made", "warning");
        setOpenModal(false);
      } else {
        editProdCodeType(editRowData);
      }
    }
  };
  useEffect(() => {
    setSelectedRows([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.producerCodeTypesId);
    BulkDeleteProducerCodeType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  //validation
  useEffect(() => {
    if (
      newData[0].producerCodeTypesName?.length > 0 ||
      editRowData?.producerCodeTypesName?.length > 0
    ) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [newData[0], editRowData]);

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Producer Code Types" : "Producer Code Type"
    }?`}</div>
  );
  const matColumns = [
    {
      title: "Producer Code Type",
      field: "producerCodeTypesName",
      customSort: (a, b) =>
        a.producerCodeTypesName && b.producerCodeTypesName
          ? a.producerCodeTypesName
              .trim()
              .localeCompare(b.producerCodeTypesName.trim())
          : a.producerCodeTypesName
          ? 0
          : -1,
      render: (rowData) => {
        return (rowData.producerCodeTypesId ===
          editRowData?.producerCodeTypesId &&
          editState) ||
          addState ? (
          <div className="w-full">
            <div className="">
              <TextInput
                defaultValue={rowData.producerCodeTypesName}
                onChange={(e) =>
                  handlesFieldsChange("producerCodeTypesName", e.target.value)
                }
              />
            </div>
          </div>
        ) : (
          <div className="w-full text-quinary font-bold uppercase text-sm">
            {rowData.producerCodeTypesName}
          </div>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: addState || editState,
    },
    {
      title: "Created Date",
      field: "createdDate",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: addState || editState,
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      field: "isActive",
      title: "Status",
      align: "left",
      render: (rowData) => {
        return (rowData.producerCodeTypesId ===
          editRowData?.producerCodeTypesId &&
          editState) ||
          addState ? (
          <div className="flex justify-start place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handlesFieldsChange("isActive", e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {updatedStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      hidden: addState,
      render: (rowData) => {
        return (rowData.producerCodeTypesId ===
          editRowData?.producerCodeTypesId &&
          editState) ||
          addState ? (
          <div className="flex justify-center space-x-1">
            <SaveButton
              buttonText="Save"
              disabled={
                disableSave ||
                (rowData?.producerCodeTypesName ===
                  editRowData?.producerCodeTypesName &&
                  rowData?.isActive === editRowData?.isActive)
              }
              onClick={() => setOpenModal(true)}
            />
            <CancelButton onClick={() => handleCancel()} />
          </div>
        ) : (
          <div className=" flex items-center place-content-center mr-5">
            {userPermissions.includes(hasEdit) && (
              <EditButton
                disabled={editState || selectedRows.length > 0}
                onClick={() => {
                  handleEdit(rowData);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="bg-white p-4 ">
      {!addState && (
        <>
          <div className="flex flex-row justify-between items-center">
            <TableFilters
              setProdCodeTypeFilteredData={setProdCodeTypeFilteredData}
              setCProgramFilteredData={setCProgramFilteredData}
              setLOBTypeFilteredData={setLOBTypeFilteredData}
              setMgaFilteredData={setMgaFilteredData}
              setDisChannelFilteredData={setDisChannelFilteredData}
              setCodeLevelFilteredData={setCodeLevelFilteredData}
              setFilterText={setFilterText}
              placeholder="Producer Code Type"
              disabledButton={editState || selectedRows.length > 0}
            />

            <div className="">
              {userPermissions.includes(hasAdd) && (
                <AddButton
                  buttonText="New Producer Code Type"
                  className={
                    selectedRows?.length > 0 || editState
                      ? "opacity-50 float-right"
                      : "opacity-100 float-right"
                  }
                  onClick={() => handleAdd()}
                  disabled={selectedRows?.length > 0 || editState}
                />
              )}
            </div>
          </div>
          <div>
            {userPermissions.includes(hasDelete) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>
        </>
      )}
      <div
        className={
          addState ? "px-3 py-2 border-l-2  border-primary box-shadow" : ""
        }
      >
        {addState && (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold">
                Add New Producer Code Type
              </div>
              <div className="flex items-center space-x-2 pt-2 pb-2">
                <SaveButton
                  buttonText="Save"
                  disabled={disableSave}
                  onClick={() => setOpenModal(true)}
                />
                <CancelButton onClick={() => handleCancel()} />
              </div>
            </div>
            <div className="h-0.5 w-full border-b-2 border-secondary " />
          </div>
        )}
        <div className={addState ? "py-3" : ""}>
          <MaterialProducerCodeConfigTable
            data={
              addState
                ? newData
                : prodCodeTypeFilteredData?.length > 0
                ? prodCodeTypeFilteredData
                : producerTypeData
            }
            isLoading={prodTypeData.isFetching}
            columns={matColumns}
            isDeactivate={true}
            onSelectionChange={handleSelectedRowsChange}
            selectedRows={selectedRows}
            selection={
              !addState && !editState && userPermissions.includes(hasDelete)
            }
            setOpenModal={setOpenModalDelete}
            paging={!addState}
          />
          <div>
            <ConfirmBoxModal
              ModalTitle={
                addState
                  ? "Add Producer Code Type"
                  : "Update Producer Code Type"
              }
              qConfirmation={
                addState
                  ? "Are you sure you want to Add this?"
                  : " Are you sure you want to Update this?"
              }
              isOpen={openModal}
              onClose={() => setOpenModal(false)}
              onClickFunction={() => {
                handleSave();
              }}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Producer Code Type"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProducerCodeTypeTable;
